export default __webpack_public_path__ + "static/media/myclassic6.0b650e75.png";